import Vue from 'vue';
import MessageItem from './message-item.vue';
import ReplyComposer from './reply-composer.vue';
import { safeUrl, studentName } from '../utils';
export default Vue.extend({
    name: 'GlobalCommbookDetail',
    components: { MessageItem: MessageItem, ReplyComposer: ReplyComposer },
    props: {
        conversation: { type: Object, default: null },
        onSent: { type: Function, required: true },
        actorId: { type: String, required: true },
        canReply: Boolean,
        canEdit: Boolean,
        canDelete: Boolean,
        loading: Boolean,
        empty: Boolean,
        error: { type: String, default: '' }
    },
    computed: {
        name: function () {
            return studentName(this.conversation || {});
        },
        studentPhoto: function () {
            return safeUrl(this.conversation && this.conversation.studentPhoto);
        },
        replies: function () {
            var replies = this.conversation && this.conversation.responseDTOList;
            return Array.isArray(replies) ? replies : [];
        }
    },
    watch: {
        conversation: {
            immediate: true,
            handler: function (current, previous) {
                var _this = this;
                if (!current)
                    return;
                var currentReplies = Array.isArray(current.responseDTOList) ? current.responseDTOList : [];
                var previousReplies = previous && Array.isArray(previous.responseDTOList) ? previous.responseDTOList : [];
                var previousIds = new Set(previousReplies.map(function (reply) { return String(reply.id); }));
                var openedConversation = !previous || String(current.id) !== String(previous.id);
                var hasNewReply = currentReplies.some(function (reply) { return !previousIds.has(String(reply.id)); });
                if (!openedConversation && !hasNewReply)
                    return;
                var conversationId = String(current.id);
                this.$nextTick(function () {
                    if (!_this.conversation || String(_this.conversation.id) !== conversationId)
                        return;
                    var scroll = _this.$refs.messageScroll;
                    if (scroll)
                        scroll.scrollTop = scroll.scrollHeight;
                });
            }
        }
    }
});
